// https://awtltrack.com/app/index.php?c=vehicletracking&a=detailtrackdata
// {"companyId":"3298","userId":31225,"isadmin":"1","driver":"","vehicleNo":"","status":"normal","offset":0,"limit":50}

import { encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import config from "../config";

class TemperatureDashboardStore {
  total = 0;
  temperatureArray = [];
  sensorDataArray = [];
  deviceDataArray = [];
  deviceSubgroupArray = [];
  temperatureReportArray = [];
  vehiclesDataArray = [];
  temperatureGraphArray = [];
  temperatureTableArray = [];
  sensorGraphArray = [];
  rootStore;
  loading = false;
  dataarray = [];

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      temperatureArray: observable,
      sensorDataArray: observable,
      loadData: action,
      loadSensorTableData: action,
      getDeviceGroups: action,
      getSubGroups: action,
      loadVehiclesData: action,
      loadTemperatureGraphData: action,
      deviceSubgroupArray: observable,
      loading: observable,
      deviceDataArray: observable,
      temperatureReportArray: observable,
      vehiclesDataArray: observable,
      temperatureGraphArray: observable,
      temperatureTableArray: observable,
      sensorGraphArray: observable,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, userId, isadmin, offset, limit }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      driver: "",
      vehicleNo: "",
      status: "normal",
      offset: offset,
      limit: limit,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/DetailTracking/getDetailtrackDataByCH", {
          params: postData,
        });
      //var response = await postApi.getClient("").get("http://localhost:3059/DetailTracking/getDetailtrackDataByCH", { params: postData });
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=sensorData",
          "postData=" + base64Input,
        );
    }

    // console.log(response?.data?.data);
    this.temperatureArray = response?.data?.data?.detailtrack;
    this.total = response?.data?.data?.TotalCount;

    if (config.pythonReport === 1) {
      this.dataarray1 = response?.data?.data?.totalvehstate;
      this.totalcount = this.dataarray1.TotalVehCount + this.dataarray1.expired;
      this.totalSensorCount =
        this.dataarray1.ActiveSensor + this.dataarray1.FaultySensor;
    }
    // console.log(response?.data?.data?.detailtrack);
    this.loading = false;
    return response?.data?.data?.detailtrack;
  }
  async getroutedata({ companyId, userId, isadmin }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/DetailTracking/getDetailtrackDataByCH", {
          params: postData,
        });
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=getLiveRouteData",
          "postData=" + base64Input,
        );
    }

    // console.log(response?.data?.data);
    this.dataarray = response?.data?.data?.totalvehstate;
    // console.log(response?.data?.data?.totalvehstate);
    this.loading = false;
    return response?.data?.data?.totalvehstate;
  }

  async loadSensorTableData({ companyId, userId, isadmin, type, isSensorTab }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      type: type,
      isSensorTab: isSensorTab,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      //var response = await postApi.getClient("NodeCoreUrl").get("/TempratureDashboard/getSensorDataCH", { params: postData });
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/TempratureDashboard/getSensorDataCH", {
          params: postData,
        });
      //var response = await postApi.getClient("").get("http://localhost:3080/TempratureDashboard/getSensorDataCH", { params: postData });
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicletracking&a=sensorFilterDetail",
          "postData=" + base64Input,
        );
    }

    this.sensorDataArray = response?.data?.data;
    this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
    return response?.data?.data;
  }

  async getDeviceGroups({ companyId, userId, isadmin }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/TrackByGroup/gettrackByGroup", {
          params: postData,
        });
      //var response = await postApi.getClient("").get(config.NodeUrl + "/deviceGroup/getVehicleGroups", {params: postData});

      this.deviceDataArray = response?.data?.data;
    } else {
      var response = await postApi
        .getClient()
        .post(
          "index.php?c=devicegroup&a=getVehicleGropups",
          "postData=" + base64Input,
        );

      this.deviceDataArray = response?.data?.data;
    }
    //this.deviceDataArray = response?.data?.VehicleGroupData;
    // this.total = parseInt(response?.data?.data?.TotalCount);
    // this.vehiclesArray=response?.data?.data?.children

    this.loading = false;
    return this.deviceDataArray; //response?.data?.data;
  }

  async getSubGroups({
    deviceGroupId,
    deviceSubGroupId,
    companyId,
    userId,
    isadmin,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      userId: userId,
      isadmin: isadmin,
      deviceSubGroupId: deviceGroupId, //null,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // if(config.pythonReport === 1){

    //     var response = await postApi
    //     .getClient("")
    //     .get(config.NodeUrl + "/deviceGroup/getSubGroupData", {
    //       params: postData,
    //     });
    //     this.deviceSubgroupArray = response?.data?.DeviceGroupData[0]?.deviceSubgroups
    //     this.loading = false;
    //     return response?.data?.DeviceGroupData[0]?.deviceSubgroups;
    // }
    // else{
    var response = await postApi
      .getClient()
      .post("index.php?c=devicegroup&a=getGroups", "postData=" + base64Input);

    this.deviceSubgroupArray = response?.data?.data;
    // this.total = parseInt(response?.data?.data?.TotalCount);

    this.loading = false;
    return response?.data?.data;
    // }
  }

  async temperatureReportData({
    companyId,
    vehicleId,
    userId,
    isadmin,
    offset,
    limit,
    fromDate,
    toDate,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      temp1min: "",
      temp1max: "",
      temp2min: "",
      temp2max: "",
      temp3min: "",
      temp3max: "",
      intervel: 5,
      fromDate: fromDate,
      showFlag: 0,
      toDate: toDate,
      offset: 0,
      limit: 15,
      page: 1,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/tracking_report/trackData", postData);
    } else {
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=temprep", "postData=" + base64Input);
    }

    if (config.pythonReport === 1) {
      this.temperatureReportArray = response?.data?.data?.completereport;
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      this.temperatureReportArray = response?.data?.data?.temprep;
      this.total = parseInt(response?.data?.data?.TotalCount);
    }
    this.loading = false;
    // console.log(response?.data?.data);

    // console.log(response?.data?.data?.temprep);

    //return response?.data?.data?.temprep;
    return this.temperatureReportArray;
  }
  async loadVehiclesData({ companyId, userId, isadmin, type }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
    };
    if (config.pythonReport == 1) {
      var response = await postApi
        .getClient("")
        .get(config.NodeUrl + "/vehicle/getVehicles", { params: postData });
      this.vehiclesDataArray = response?.data?.vehicleData;
      this.total = parseInt(response?.data?.TotalCount);
      this.loading = false;
      return response?.data?.vehicleData;
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
      this.vehiclesDataArray = response?.data?.data;
      this.total = parseInt(response?.data?.data?.TotalCount);
      this.loading = false;
      return response?.data?.data;
    }
  }

  async loadTemperatureGraphData({
    companyId,
    userId,
    isadmin,
    vehicleId,
    fromDate,
    toDate,
  }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      intervel: 20,
      fromDate: fromDate,
      toDate: toDate,
      offset: 0,
      limit: 15,
      page: 1,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/tracking_report/trackData", postData);
    } else {
      var response = await postApi
        .getClient()
        .post("index.php?c=vehicle&a=tempGraph", "postData=" + base64Input);
    }

    if (config.pythonReport === 1) {
      this.temperatureTableArray = response?.data?.data?.completereport;
      var tempGraphData = response?.data?.data?.completereport;
    } else {
      this.temperatureTableArray = response?.data?.data?.temprep;
      var tempGraphData = response?.data?.data?.temprep;
    }

    if (tempGraphData) {
      tempGraphData.forEach((element) => {
        element.temp2 = element.temp2 ? Number(element.temp2) : 0;
        element.temp1 = Number(element.temp1);
        element.temp3 = element.temp3 ? Number(element.temp3) : 0;
        element.temp4 = element.temp4 ? Number(element.temp4) : 0;
      });
    }
    this.temperatureGraphArray = tempGraphData;

    // console.log( this.temperatureGraphArray )
  }

  async loadGateways({ companyId, userId, isadmin, type }) {
    try {
      this.loading = true;

      var postData = {
        companyId: companyId,
        userId: userId,
        isadmin: isadmin,
      };
      if (config.pythonReport == 1) {
        var response = await postApi
          .getClient("")
          .post(
            config.NodeUrl + "/TempratureDashboard/getGatewayVehicles",
            postData,
          );
      } else {
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
          .getClient()
          .post(
            "index.php?c=vehicletracking&a=getGatewayVehicles",
            "postData=" + base64Input,
          );
      }

      const gatewayList = response?.data?.data || [];

      this.gatewayDataArray = gatewayList;
      this.total = gatewayList.length || 0;
      this.loading = false;

      return gatewayList;
    } catch (error) {
      console.error("Error loading gateways:", error);
      this.loading = false;
      return [];
    }
  }

  async loadSensorDetailsByIds(companyId, vehicleId, sensorId) {
    try {
      this.loading = true;

      const postData = {
        companyId: companyId,
        //deviceId: deviceIds,//Array.isArray(deviceIds) ? deviceIds.join(",") : deviceIds,
        vehicleId: vehicleId,
        sensorId: sensorId,
      };
      let response;

      if (config.pythonReport == 1) {
         response = await postApi
          .getClient("")
          .post(
            config.NodeUrl + "/TempratureDashboard/getSensorDetails",
            postData,
          );
      } else {
        const base64Input = await base64_encode(JSON.stringify(postData));

         response = await postApi
          .getClient()
          .post(
            "index.php?c=vehicletracking&a=getSensorDetails",
            "postData=" + base64Input,
          );
      }

      this.loading = false;

      return response?.data?.data || [];
    } catch (e) {
      console.error("Error loading sensor details:", e);
      this.loading = false;
      return [];
    }
  }

  async loadSensorsByGateways(companyId, vehicleIds) {
    try {
      this.loading = true;

      const postData = {
        companyId: companyId,
        vehicleId: vehicleIds,
      };
      let response;

      if (config.pythonReport == 1) {
         response = await postApi
          .getClient("")
          .post(config.NodeUrl + "/TempratureDashboard/getSensors", postData);
      } else {
        const base64Input = await base64_encode(JSON.stringify(postData));
         response = await postApi
          .getClient()
          .post(
            "index.php?c=vehicletracking&a=getSensors",
            "postData=" + base64Input,
          );
          console.log(response.data.data)
     
      }

     
      this.loading = false;
      

      return response?.data?.data || [];
    } catch (e) {
      console.error("Error loading sensor details:", e);
      this.loading = false;
      return [];
    }
  }

  async loadSensorGraphData({
    companyId,
    vehicleId,
    fromDate,
    toDate,
    sensorId,
  }) {
    this.loading = true;

    var postData = {
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      sensorId: sensorId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=vehicletracking&a=getSensorGraph",
        "postData=" + base64Input,
      );

    const graphData = response?.data?.data || [];

    // ✅ Prepare the graph data
    const formattedData = graphData.map((item) => ({
      timestamp: item.timestamp,
      temperature: Number(item.sensorTemperature || 0),
      humidity: Number(item.humidity || 0),
      vehicleNo: item.vehicleNo,
    }));

    return formattedData;
    //this.sensorGraphArray = formattedData;

    console.log("this.sensorGraphArray", this.sensorGraphArray);

    // [
    //   { timestamp: "2025-11-05 00:00:00", temperature: 20, humidity: 50 },
    //   { timestamp: "2025-11-05 01:00:00", temperature: 22, humidity: 48 },
    //   { timestamp: "2025-11-05 02:00:00", temperature: 21, humidity: 45 },
    // ];
  }
}
export default TemperatureDashboardStore;
